import React from "react";

const PromoButton = (props) => {
  const { img, labelOne, labelTwo, link } = props;

  return (
    <a href={link}>
      <div className="promo-button-container">
        {img}
        <div style={{ fontWeight: "bold" }}>{labelOne}&nbsp;</div>
        <div style={{ fontWeight: 400 }}>{labelTwo}</div>
      </div>
    </a>
  );
};

export default PromoButton;
